import { withStyles } from '@material-ui/core';
import CustomCardHeader from './CustomCardHeader';
import styles from './styles';


export default withStyles(styles)(CustomCardHeader);
